import {
  type AdminSessionList,
  type RevokeSessionResult,
  adminSessionListSchema,
  revokeSessionResultSchema,
} from '@xphoto/shared';
import { apiFetch } from '../lib/http';
import { AdminApiError } from './admin-api';

/**
 * Client typé des SESSIONS ACTIVES (audit B2) — superadmin. Réponses re-parsées par
 * leur schéma partagé. Aucun jeton n'est manipulé en JS : les cookies de session sont
 * same-origin, et la réponse ne porte JAMAIS le `token_hash`.
 */

async function readJson(res: Response): Promise<unknown> {
  if (!res.ok) {
    let code = 'UNKNOWN';
    try {
      const body = (await res.json()) as { error?: { code?: string } };
      if (typeof body?.error?.code === 'string') code = body.error.code;
    } catch {
      // Corps non-JSON : code générique.
    }
    throw new AdminApiError(res.status, code);
  }
  return res.json();
}

/** `GET /api/admin/users/:id/sessions` — sessions vivantes d'un compte. */
export async function fetchUserSessions(
  userId: string,
  signal?: AbortSignal,
): Promise<AdminSessionList> {
  const res = await apiFetch(`/api/admin/users/${userId}/sessions`, {
    credentials: 'same-origin',
    signal: signal ?? null,
  });
  return adminSessionListSchema.parse(await readJson(res));
}

/** `DELETE /api/admin/sessions/:sessionId` — révocation unitaire (idempotente). */
export async function revokeSession(sessionId: string): Promise<RevokeSessionResult> {
  const res = await apiFetch(`/api/admin/sessions/${sessionId}`, {
    method: 'DELETE',
    credentials: 'same-origin',
  });
  return revokeSessionResultSchema.parse(await readJson(res));
}
